const MockUpService = {
	TelegramWebApi: {
		WebApp: {
			initData:
				'query_id=AAF8elY4AAAAAHx6VjhN_JS3&user=%7B%22id%22%3A945191548%2C%22first_name%22%3A%22Alex%22%2C%22last_name%22%3A%22Johson%22%2C%22username%22%3A%22alexJohson%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%7D&auth_date=1731087907&hash=4d98f8a91f3963a5de79d28cd80dca7145d4048a7481f75cb61e8dbd309bedc4', // Raw string with data transferred to the Mini App
			initDataUnsafe: {
				query_id: 'AAF8elY4AAAAAHx6VjhN_JS3',
				user: {
					id: 945191548,
					first_name: 'Alex',
					last_name: 'Johnson',
					username: 'alexJohnson',
					language_code: 'ru',
					allows_write_to_pm: true,
				},
				auth_date: '1731087907',
				hash: '4d98f8a91f3963a5de79d28cd80dca7145d4048a7481f75cb61e8dbd309bedc4',
			},
			version: '7.10', // Bot API version
			platform: 'tdesktop', // Platform the app is running on (e.g., "android", "ios", "tdesktop")
			colorScheme: 'dark', // Current color scheme: "light" or "dark"
			themeParams: {
				accent_text_color: '#6ab2f2',
				bg_color: '#17212b',
				bottom_bar_bg_color: '#17212b',
				button_color: '#5288c1',
				button_text_color: '#ffffff',
				destructive_text_color: '#ec3942',
				header_bg_color: '#17212b',
				hint_color: '#708499',
				link_color: '#6ab3f3',
				secondary_bg_color: '#232e3c',
				section_bg_color: '#17212b',
				section_header_text_color: '#6ab3f3',
				section_separator_color: '#111921',
				subtitle_text_color: '#708499',
				text_color: '#f5f5f5',
			},
			isExpanded: false, // Whether the Mini App is expanded
			viewportHeight: 590, // Height of the visible area in pixels
			viewportStableHeight: 590, // Last stable height of the visible area
			headerColor: '#17212b', // Current header color
			backgroundColor: '#17212b', // Current background color
			bottomBarColor: '#17212b', // Current bottom bar color
			isClosingConfirmationEnabled: false, // Whether closing confirmation is enabled
			isVerticalSwipesEnabled: true, // Whether vertical swipes are enabled to close/minimize
			// safeAreaInset: { top: 50, bottom: 16 },
			// contentSafeAreaInset: { top: 44 },

			// Back button control object
			BackButton: {
				isVisible: false,
				show: () => {
					window.Telegram.WebApp.BackButton.isVisible = true;
					////console.log('BackButton shown.');
				},
				hide: () => {
					window.Telegram.WebApp.BackButton.isVisible = false;
					////console.log('BackButton hidden.');
				},
				onClick: callback => {
					////console.log('BackButton click event registered.');
				},
				offClick: callback => {
					////console.log('BackButton click event unsubscribe.');
				},
			},

			// Main button control object
			MainButton: {
				// Default values
				type: 'main', // Readonly: 'main' for MainButton
				text: 'Continue', // Default text for MainButton
				color: 'themeParams.button_color', // Default color from themeParams
				textColor: 'themeParams.button_text_color', // Default text color from themeParams
				isVisible: false, // Button visibility default is false
				isActive: true, // Button is active by default
				hasShineEffect: false, // Bot API 7.10+: No shine effect by default
				position: undefined, // No position for MainButton
				isProgressVisible: false, // Readonly: shows if progress indicator is visible

				// Method to set the button text
				setText: function (text) {
					this.text = text;
					//console.log(`MainButton text set to: ${this.text}`);
				},

				// Method to register a click event handler
				onClick: function (callback) {
					////console.log('MainButton click event registered.');
					window.Telegram.WebApp.onEvent('mainButtonClicked', callback);
				},

				// Method to remove a click event handler
				offClick: function (callback) {
					////console.log('MainButton click event removed.');
					window.Telegram.WebApp.offEvent('mainButtonClicked', callback);
				},

				// Method to make the button visible
				show: function () {
					this.isVisible = true;
					////console.log('MainButton is now visible.');
				},

				// Method to hide the button
				hide: function () {
					this.isVisible = false;
					////console.log('MainButton is now hidden.');
				},

				// Method to enable the button
				enable: function () {
					this.isActive = true;
					////console.log('MainButton is now active.');
				},

				// Method to disable the button
				disable: function () {
					this.isActive = false;
					////console.log('MainButton is now disabled.');
				},

				// Method to show the progress indicator on the button
				showProgress: function (leaveActive = false) {
					this.isProgressVisible = true;
					if (!leaveActive) {
						this.isActive = false;
					}
					////console.log('MainButton progress indicator is now visible.');
				},

				// Method to hide the progress indicator
				hideProgress: function () {
					this.isProgressVisible = false;
					////console.log('MainButton progress indicator is now hidden.');
				},

				// Method to set multiple parameters of the button
				setParams: function (params) {
					if (params.text !== undefined) this.text = params.text;
					if (params.color !== undefined) this.color = params.color;
					if (params.text_color !== undefined) this.textColor = params.text_color;
					if (params.has_shine_effect !== undefined) this.hasShineEffect = params.has_shine_effect;
					if (params.is_active !== undefined) this.isActive = params.is_active;
					if (params.is_visible !== undefined) this.isVisible = params.is_visible;

					////console.log('MainButton parameters updated:', params);
				},
			},
			// Secondary button control object
			SecondaryButton: {
				// Default values
				type: 'secondary', // Readonly: 'secondary' for SecondaryButton
				text: 'Cancel', // Default text for SecondaryButton
				color: 'themeParams.bottom_bar_bg_color', // Default color from themeParams for secondary button
				textColor: 'themeParams.button_color', // Default text color from themeParams for secondary button
				isVisible: false, // Button visibility default is false
				isActive: true, // Button is active by default
				hasShineEffect: false, // Bot API 7.10+: No shine effect by default
				position: 'left', // Default position is 'left', applies only if main and secondary buttons are visible
				isProgressVisible: false, // Readonly: shows if progress indicator is visible

				// Method to set the button text
				setText: function (text) {
					this.text = text;
					//console.log(`SecondaryButton text set to: ${this.text}`);
				},

				// Method to register a click event handler
				onClick: function (callback) {
					////console.log('SecondaryButton click event registered.');
					window.Telegram.WebApp.onEvent('secondaryButtonClicked', callback);
				},

				// Method to remove a click event handler
				offClick: function (callback) {
					////console.log('SecondaryButton click event removed.');
					window.Telegram.WebApp.offEvent('secondaryButtonClicked', callback);
				},

				// Method to make the button visible
				show: function () {
					this.isVisible = true;
					////console.log('SecondaryButton is now visible.');
				},

				// Method to hide the button
				hide: function () {
					this.isVisible = false;
					////console.log('SecondaryButton is now hidden.');
				},

				// Method to enable the button
				enable: function () {
					this.isActive = true;
					////console.log('SecondaryButton is now active.');
				},

				// Method to disable the button
				disable: function () {
					this.isActive = false;
					////console.log('SecondaryButton is now disabled.');
				},

				// Method to show the progress indicator on the button
				showProgress: function (leaveActive = false) {
					this.isProgressVisible = true;
					if (!leaveActive) {
						this.isActive = false;
					}
					////console.log('SecondaryButton progress indicator is now visible.');
				},

				// Method to hide the progress indicator
				hideProgress: function () {
					this.isProgressVisible = false;
					////console.log('SecondaryButton progress indicator is now hidden.');
				},

				// Method to set multiple parameters of the button
				setParams: function (params) {
					if (params.text !== undefined) this.text = params.text;
					if (params.color !== undefined) this.color = params.color;
					if (params.text_color !== undefined) this.textColor = params.text_color;
					if (params.has_shine_effect !== undefined) this.hasShineEffect = params.has_shine_effect;
					if (params.position !== undefined) this.position = params.position;
					if (params.is_active !== undefined) this.isActive = params.is_active;
					if (params.is_visible !== undefined) this.isVisible = params.is_visible;

					////console.log('SecondaryButton parameters updated:', params);
				},
			},
			// Settings button control object
			SettingsButton: {
				// Default values
				isVisible: false, // By default, the Settings menu item is hidden

				// Method to register a click event handler for the Settings item
				onClick: function (callback) {
					////console.log('SettingsButton click event registered.');
					window.Telegram.WebApp.onEvent('settingsButtonClicked', callback);
				},

				// Method to remove the click event handler for the Settings item
				offClick: function (callback) {
					////console.log('SettingsButton click event removed.');
					window.Telegram.WebApp.offEvent('settingsButtonClicked', callback);
				},

				// Method to make the Settings menu item visible
				show: function () {
					this.isVisible = true;
					////console.log('SettingsButton is now visible.');
				},

				// Method to hide the Settings menu item
				hide: function () {
					this.isVisible = false;
					////console.log('SettingsButton is now hidden.');
				},
			},
			// Haptic feedback control
			HapticFeedback: {
				impactOccurred: (style = 'light') => {
					//console.log(`Haptic feedback: ${style} impact occurred.`);
				},
				notificationOccurred: (type = 'success') => {
					//console.log(`Haptic notification: ${type}.`);
				},
				selectionChanged: () => {
					////console.log('Haptic selection changed.');
				},
			},

			// Cloud storage control object
			CloudStorage: {
				setItem: (key, value, callback) => {
					try {
						if (/^[A-Za-z0-9_-]{1,128}$/.test(key) && value.length <= 4096) {
							localStorage.setItem(key, JSON.stringify(value));
							//console.log(`Set item in CloudStorage: ${key}: ${value}`);
							if (callback) callback(null, true); // Success callback
						} else {
							throw new Error('Invalid key or value size exceeded');
						}
					} catch (error) {
						if (callback) callback(error); // Error callback
					}
				},

				getItem: (key, callback) => {
					try {
						if (/^[A-Za-z0-9_-]{1,128}$/.test(key)) {
							const value = localStorage.getItem(key);

							//console.log(`Get item from CloudStorage: ${key}: ${value}`);

							if (callback) callback(null, value); // Success callback
						} else {
							throw new Error('Invalid key');
						}
					} catch (error) {
						if (callback) callback(error); // Error callback
					}
				},

				getItems: (keys, callback) => {
					try {
						const values = {};
						keys.forEach(key => {
							if (/^[A-Za-z0-9_-]{1,128}$/.test(key)) {
								values[key] = JSON.parse(localStorage.getItem(key));
							}
						});
						//console.log(`Get items from CloudStorage: ${keys}: ${values}`);
						if (callback) callback(null, values); // Success callback
					} catch (error) {
						if (callback) callback(error); // Error callback
					}
				},

				removeItem: (key, callback) => {
					try {
						if (/^[A-Za-z0-9_-]{1,128}$/.test(key)) {
							localStorage.removeItem(key);
							//console.log(`Removed item from CloudStorage: ${key}`);
							if (callback) callback(null, true); // Success callback
						} else {
							throw new Error('Invalid key');
						}
					} catch (error) {
						if (callback) callback(error); // Error callback
					}
				},

				removeItems: (keys, callback) => {
					try {
						keys.forEach(key => {
							if (/^[A-Za-z0-9_-]{1,128}$/.test(key)) {
								localStorage.removeItem(key);
							}
						});
						//console.log(`Removed items from CloudStorage: ${keys}`);
						if (callback) callback(null, true); // Success callback
					} catch (error) {
						if (callback) callback(error); // Error callback
					}
				},

				getKeys: callback => {
					try {
						const keys = Object.keys(localStorage).filter(key => /^[A-Za-z0-9_-]{1,128}$/.test(key));
						//console.log(`Get keys from CloudStorage: ${keys}`);
						if (callback) callback(null, keys); // Success callback
					} catch (error) {
						if (callback) callback(error); // Error callback
					}
				},
			},
			// Biometric control object
			BiometricManager: {
				// Default values
				isInited: false, // Indicates if the biometrics object is initialized
				isBiometricAvailable: false, // Indicates if biometrics are available on the device
				biometricType: 'unknown', // Type of biometrics available ('finger', 'face', 'unknown')
				isAccessRequested: false, // Indicates if biometrics permission has been requested
				isAccessGranted: false, // Indicates if permission for biometrics has been granted
				isBiometricTokenSaved: false, // Indicates if the biometric token is saved on the device
				deviceId: '', // Unique device identifier

				// Method to initialize the BiometricManager object
				init: function (callback) {
					////console.log('Initializing BiometricManager...');
					this.isInited = true;
					if (callback) {
						callback();
					}
				},

				// Method to request permission to use biometrics
				requestAccess: function (params, callback) {
					////console.log('Requesting biometric access...');
					this.isAccessRequested = true;
					// Simulate user granting access for example purposes
					this.isAccessGranted = true; // Change as needed in a real implementation
					if (callback) {
						callback(this.isAccessGranted);
					}
				},

				// Method to authenticate the user using biometrics
				authenticate: function (params, callback) {
					////console.log('Authenticating user with biometrics...');
					let success = true; // Simulated success, change logic as needed
					let biometricToken = 'simulated_biometric_token'; // Example token

					if (callback) {
						callback(success, biometricToken);
					}
				},

				// Method to update the biometric token in secure storage
				updateBiometricToken: function (token, callback) {
					////console.log('Updating biometric token...');
					if (token === '') {
						this.isBiometricTokenSaved = false; // Removing the token
					} else {
						this.isBiometricTokenSaved = true; // Token saved
					}
					if (callback) {
						callback(this.isBiometricTokenSaved);
					}
				},

				// Method to open biometric access settings
				openSettings: function () {
					////console.log('Opening biometric settings...');
					// Simulated opening of settings (to be replaced by actual implementation)
				},
			},
			// Functions
			isVersionAtLeast: version => {
				//console.log(`Check if version is at least: ${version}`);
				return true; // Mock return true for the version check
			},
			setHeaderColor: color => {
				//console.log(`Set header color to ${color}`);
			},
			setBackgroundColor: color => {
				//console.log(`Set background color to ${color}`);
			},
			setBottomBarColor: color => {
				//console.log(`Set bottom bar color to ${color}`);
			},
			enableClosingConfirmation: () => {
				window.Telegram.WebApp.isClosingConfirmationEnabled = true;
				////console.log('Closing confirmation enabled.');
			},
			disableClosingConfirmation: () => {
				window.Telegram.WebApp.isClosingConfirmationEnabled = false;
				////console.log('Closing confirmation disabled.');
			},
			enableVerticalSwipes: () => {
				window.Telegram.WebApp.isVerticalSwipesEnabled = true;
				////console.log('Vertical swipes enabled.');
			},
			disableVerticalSwipes: () => {
				window.Telegram.WebApp.isVerticalSwipesEnabled = false;
				////console.log('Vertical swipes disabled.');
			},
			requestFullscreen: () => {
				window.Telegram.WebApp.isFullscreen = true;
				////console.log('Fullscreen activated.');
			},
			exitFullscreen: () => {
				window.Telegram.WebApp.isFullscreen = false;
				////console.log('Fullscreen deactivated.');
			},
			onEvent: (eventType, eventHandler) => {
				//console.log(`Event '${eventType}' registered.`);
			},
			offEvent: (eventType, eventHandler) => {
				//console.log(`Event '${eventType}' unregistered.`);
			},
			sendData: data => {
				////console.log('Data sent to Telegram:', data);
			},
			switchInlineQuery: (query, choose_chat_types = []) => {
				//console.log(`Switch to inline query: ${query} for chat types: ${choose_chat_types}`);
			},
			openLink: (url, options = {}) => {
				//console.log(`Opening link: ${url} with options:`, options);
			},
			openTelegramLink: url => {
				//console.log(`Opening Telegram link: ${url}`);
			},
			openInvoice: (url, callback) => {
				//console.log(`Opening invoice: ${url}`);
				callback && callback('paid'); // Mock invoice paid status
			},
			shareToStory: (media_url, params = {}) => {
				//console.log(`Sharing to story with media URL: ${media_url} and params:`, params);
			},
			showPopup: (params, callback) => {
				//console.log(`Showing popup with params:`, params);
				callback && callback('button_id'); // Mock popup button press
			},
			showAlert: (message, callback) => {
				//console.log(`Alert: ${message}`);
				callback && callback();
			},
			showConfirm: (message, callback) => {
				//console.log(`Confirm: ${message}`);
				callback && callback(true); // Mock OK button press
			},
			showScanQrPopup: (params, callback) => {
				//console.log(`Showing QR scan popup with params:`, params);
				callback && callback('mock_qr_text'); // Mock QR scan text
			},
			closeScanQrPopup: () => {
				////console.log('Closing QR scan popup.');
			},
			readTextFromClipboard: callback => {
				////console.log('Reading text from clipboard.');
				callback && callback('mock_clipboard_text'); // Mock clipboard text
			},
			requestWriteAccess: callback => {
				////console.log('Requesting write access.');
				callback && callback(true); // Mock access granted
			},
			requestContact: callback => {
				////console.log('Requesting contact.');
				callback && callback(true); // Mock contact shared
			},
			ready: () => {
				////console.log('Mini App is ready.');
			},
			expand: () => {
				window.Telegram.WebApp.isExpanded = true;
				////console.log('Mini App expanded.');
			},
			close: () => {
				////console.log('Mini App closed.');
			},
			lockOrientation: orientation => {
				//console.log(`${orientation} was locked`);
			},
		},
	},
};

export default MockUpService;
